import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { arrowLeft } from "../../Components";
import JobCampaignsMain from "./JobCampaignsMain";
import { useLocation, useNavigate } from "react-router-dom";
import { storageHandler, utils } from "../../Helpers";
import { useSearchParams } from "react-router-dom";
import { campaignService } from "../../Services";
import JobPostMain from "./JobCampaignsCreate/JobPostMain";
import { jobCampaignsService } from "../../Services/jobCampaigns.service";
import CampaignDetailsModal from "./Components/CampaignDetailsModal";
import NotSubscribe from "../../Components/Base/Common/NotSubscribe";
import { parseInput } from "../../Components/Constants/AppConstant";

export default function JobCampaigns({
  cartItem,
  closeCartPanel,
  setSaveCampaign,
  setAuth,
  setModalSwitch,
  NotifModul,
  profiles,
  user,
  setModalNotification,
  locationData,
  setShowConfirmModal,
  setShowConfirmAction,
  saveCampaign,
  goToPricing,
  setModal,
  setCustomTitle,
  onStartChat,
  setOfferSelectedForReview

}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { data } = location.state ? location.state : {};
  const [recommandDataId, setRecommandDataId] = useState(data);
  const [tab, setTab] = useState("main");
  const [ytd, setYtd] = useState(0);
  const [modalCampaigns, setModalCampaigns] = useState(null);
  const [modalDataCampaigns, setModalDataCampaigns] = useState(null);
  const [campaignData, setCampaignData] = useState([]);
  const [isloaded, setIsLoaded] = React.useState(false);
  const [page, setPage] = useState(1);
  const [toastList, setToastList] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [paginationData, setPaginationData] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");
  const [selectDesc, setselectDesc] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [searchList, setSearchList] = useState(false);
  const [loadList, setLoadList] = useState(false);
  const [redirectToBilling, setRedirectToBilling] = useState(false);
  const [isseacrhByIdDone, setIsseacrhByIdDone] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isFetching, setIsFetching] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");

  // Refs to track loading state for scroll handler
  const isLoadingMoreRef = useRef(false);
  const hasMoreRef = useRef(true);
  const isFetchingRef = useRef(false);

  // Keep refs in sync with state
  useEffect(() => {
    isLoadingMoreRef.current = isLoadingMore;
  }, [isLoadingMore]);

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    isFetchingRef.current = isFetching;
  }, [isFetching]);

  const handleHeaderTitleChange = (title) => {
    setCustomTitle && setCustomTitle(title);
  };

  useEffect(() => {
    if (tab === "main") {
      setCustomTitle && setCustomTitle(null);
    } else if (tab === "create") {
      setCustomTitle && setCustomTitle("Create campaign");
    } else if (tab === "edit") {
      setCustomTitle && setCustomTitle("Edit campaign");
    }
  }, [tab]);

  const urlCampaignId = searchParams.get("id")
    ? searchParams.get("id") !== null || searchParams.get("id") !== undefined
      ? searchParams.get("id")
      : null
    : null;

  // const changeMedium = (item) => {
  //   setYtd(item.id);
  //   setSearchList(!searchList);
  //   setPage(1);
  //   setSearchText("");
  // };

  const sortList = () => {
    setSortOrder(sortOrder === "desc" ? "asc" : "desc");
  };

  // Edit campaign handler
  const handleEditCampaign = async (campaignData) => {
    try {
      // addToast({
      //   type: "info",
      //   title: "Edit Mode",
      //   description: "Loading campaign data for editing...",
      // });
      setIsLoaded(false);
      handleHeaderTitleChange("Edit Campaign");
      const fullCampaignData = await jobCampaignsService.getCampaignById(
        campaignData.id
      );
      console.log("Edit campaign - full data:", fullCampaignData);
      setModalDataCampaigns(fullCampaignData.data);
      setTab("create");
    } catch (error) {
      console.error("Error fetching campaign for edit:", error);
      addToast({
        type: "error",
        title: "Error",
        description:
          "Failed to load campaign data for editing. Please try again.",
      });
    } finally {
      setIsLoaded(true);
    }
  };

  // Delete campaign handler
  const handleDeleteCampaign = async (campaignId) => {
    try {
      setIsLoaded(false);
      await jobCampaignsService.deleteCampaign(campaignId);
      const latestData = campaignData?.filter(
        (campaign) => campaign.id !== campaignId
      );
      setCampaignData(latestData);

      addToast({
        type: "success",
        title: "Success",
        description: "Campaign deleted successfully",
      });
    } catch (error) {
      console.error("Error deleting campaign:", error);
      addToast({
        type: "error",
        title: "Error",
        description: "Failed to delete campaign. Please try again.",
      });
    } finally {
      setIsLoaded(true);
    }
  };

  const handleApplicationCountClick = (campaignId, campaignTitle) => {
    navigate(`/brand/application?id=${campaignId}`, {
      state: { campaignTitle: campaignTitle },
    });
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  // Function to trigger data refresh using existing useEffect
  const refreshCampaignData = useCallback(() => {
    setLoadList(!loadList); // Toggle loadList to trigger the existing useEffect
  }, [loadList]);

  useEffect(() => {
    if (tab === "main") {
      setCustomTitle && setCustomTitle(null);
    } else if (tab === "create") {
      // Check if we're in edit mode
      if (modalDataCampaigns !== null) {
        setCustomTitle && setCustomTitle("Edit campaign");
      } else {
        setCustomTitle && setCustomTitle("Create campaign");
      }
    } else if (tab === "edit") {
      setCustomTitle && setCustomTitle("Edit campaign");
    }
  }, [tab, modalDataCampaigns]);

  useEffect(() => {
    if (modalCampaigns) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modalCampaigns]);

  const changeMediumDesc = (item) => {
    setselectDesc(item);
    setPage(1);
    setCampaignData([]); // Reset data for new filter
    setHasMore(true);
    setSearchText("");
    setSearchList(!searchList);
  };

  const handleTabChange = (tabId) => {
    setSelectedTab(tabId);
    setPage(1);
    setCampaignData([]);
    setHasMore(true);
    setSearchList(!searchList);
  };

  useEffect(() => {
    if (recommandDataId === undefined) {
      setTab("main");
      setPage(1);
      setSortOrder("desc");
      setSearchText("");
    }
  }, [locationData.key]);

  useEffect(() => {
    if (recommandDataId !== undefined) {
      setTab("create");
    }
  }, [recommandDataId]);

  // Clear edit data when switching away from create tab and refresh data when switching to main
  useEffect(() => {
    if (tab !== "create") {
      setModalDataCampaigns(null);
    }
  }, [tab, isloaded, loadList, refreshCampaignData]);

  useEffect(() => {
    if (redirectToBilling === true && tab === "main") {
      setShowConfirmModal(false);
      setShowConfirmAction("");
      navigate("/brand/billing", {
        state: { openAddFunds: true },
        replace: true,
      });
    } else {
      if (tab === "create" || tab === "edit") {
        setShowConfirmModal(true);
        setShowConfirmAction(tab + "camp");
      } else {
        setShowConfirmModal(false);
        setShowConfirmAction("");
      }
    }
  }, [redirectToBilling, tab]);

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        search();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [searchText]);

  useEffect(() => {
    async function fetchData() {
      try {
        // Show loading for first page, show fetching indicator for subsequent pages
        if (page === 1) {
          setIsLoaded(false);
        } else {
          setIsLoadingMore(true);
        }
        setIsFetching(true);

        let filter = "";

        if (searchText !== "" && selectDesc !== "") {
          filter = "filter[" + selectDesc + "]=" + searchText;
        } else {
          if (
            urlCampaignId !== "" &&
            urlCampaignId !== null &&
            urlCampaignId !== undefined &&
            isseacrhByIdDone === false
          ) {
            filter = "fields[id]=" + urlCampaignId;
            setIsseacrhByIdDone(true);
          }
        }

        let cmpType = "";
        if (selectedTab === "public") cmpType = "p";
        else if (selectedTab === "private") cmpType = "r";

        const res = await jobCampaignsService.getAllCampaigns({
          page: page,
          pageSize: pageSize,
          sortBy: sortOrder,
          filter: filter,
          cmp_type: cmpType,
        });
        console.log("🚀 ~ fetchData ~ res:", res);

        if (res?.data) {
          const totalPages =
            res.data.last_page || Math.ceil((res.data.total || 0) / pageSize);
          const currentPage = res.data.current_page || page;

          console.log(
            "📊 fetchData result - page:",
            page,
            "currentPage:",
            currentPage,
            "totalPages:",
            totalPages,
            "hasMore:",
            currentPage < totalPages
          );

          setPaginationData({
            per_page: res.data.per_page || pageSize,
            total: res.data.total || 0,
            current_page: currentPage,
            total_pages: totalPages,
          });

          // For infinite scroll: append data on subsequent pages, replace on first page
          const newData = res.data.data || res.data || [];
          console.log("📊 newData length:", newData.length, "page:", page);

          if (page === 1) {
            setCampaignData(newData);
          } else {
            setCampaignData((prev) => [...prev, ...newData]);
          }

          // Check if there are more pages
          setHasMore(currentPage < totalPages);
          setSearchText("");
        } else {
          setCampaignData([]);
          setPaginationData({
            per_page: pageSize,
            total: 0,
            current_page: 1,
            total_pages: 0,
          });
          setHasMore(false);
        }

        setIsLoaded(true);
        setIsFetching(false);
        setIsLoadingMore(false);
      } catch (err) {
        if (err.apiResponseStatus !== 404) {
          let error = parseInput(err.message);
          addToast({
            error: true,
            msg: error.message,
            id: `${Date.now()}-${toastList.length}`,
          });
        } else {
          setIsLoaded(true);
        }
        setIsFetching(false);
        setIsLoadingMore(false);
      }
    }
    fetchData();
  }, [page, ytd, sortOrder, searchList, loadList, selectedTab]);

  const downloadCsv = async () => {
    try {
      let filter = "";
      if (searchText !== "") {
        if (filter !== "") {
          filter += "&filter[" + selectDesc + "]=" + searchText;
        } else {
          filter = "filter[" + selectDesc + "]=" + searchText;
        }
      }
      const response = await campaignService.getAll({
        page: page,
        pageSize: pageSize,
        fileType: "csv",
        sortBy: sortOrder,
        filter: filter,
      });
      utils.downloadFile(response, "brandCampaign_" + page + ".csv");
    } catch (err) {
      console.error("Error downloading CSV:", err);

      let errorMessage = "Failed to download CSV file";
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      } else if (err.message) {
        errorMessage = err.message;
      }

      addToast({
        type: "error",
        title: "Download Error",
        description: errorMessage,
      });
    }
  };

  const onPaginate = (page) => {
    setPage(page);
  };

  // Load more data for infinite scroll
  const loadMoreData = useCallback(() => {
    // Use refs to get latest state values
    if (
      !isLoadingMoreRef.current &&
      hasMoreRef.current &&
      !isFetchingRef.current
    ) {
      console.log("loadMoreData called - incrementing page");
      setPage((prev) => prev + 1);
    } else {
      console.log(
        "loadMoreData skipped - isLoadingMore:",
        isLoadingMoreRef.current,
        "hasMore:",
        hasMoreRef.current,
        "isFetching:",
        isFetchingRef.current
      );
    }
  }, []);

  const setSearchTextOnChange = (event) => {
    if (event.target.value === "") {
      setSearchList(!searchList);
    }
    setSearchText(event.target.value);
  };

  const search = () => {
    setCampaignData([]); // Reset data for new search
    setHasMore(true);
    setSearchList(!searchList);
    setPage(1);
  };

  let data1 = null;
  try {
    const userInfo = storageHandler.getUserInfo();
    if (userInfo) {
      const parsed = JSON.parse(userInfo);
      data1 = parsed?.data || null;
    }
  } catch (error) {
    console.error("Error parsing user info:", error);
  }

  useEffect(() => {
    // setUserHasSubscription(
    //   user !== null
    //     ? user.data.isUserHasSubscription === 1
    //       ? true
    //       : false
    //     : false
    // );
    data1.p_f_ids.includes(13);
  }, []);

  return (
    <>
      {data1.p_f_ids.includes(13) ? (
        <>
          <div className="main">
            {/* <div className="main__inner-title"> */}
            {/* {tab === "main" && (
                  <div className="main__inner-title-col">
                    <h2>Campaigns</h2>
                  </div>
                )} */}
            {/* {tab === "create" && (
                  <div className="main__inner-title-row">
                    <h2>Create a campaign</h2>
                  </div>
                )} */}
            {tab === "edit" && (
              <div className="main__inner-title-row">
                <h2>Edit campaign</h2>
                <div className="main__inner-title-status">Draft</div>
              </div>
            )}
            {tab === "insights" && modalDataCampaigns && (
              <div className="main__inner-title-col">
                <div className="main__inner-title-row">
                  <h2>{modalDataCampaigns.title}</h2>
                  <div
                    className={
                      "main__inner-title-status " + modalDataCampaigns.status
                    }
                  >
                    {modalDataCampaigns.status === "complete"
                      ? "completed on " + modalDataCampaigns.endDate
                      : modalDataCampaigns.status}
                  </div>
                </div>
                <button
                  className="button tertiary big"
                  onClick={() => setTab("main")}
                >
                  {arrowLeft} Back to all campaigns
                </button>
              </div>
            )}

            {tab === "revisiontree" && (
              <div className="main__inner-title-col">
                <div className="main__inner-title-row">
                  <h2></h2>
                </div>
              </div>
            )}

            {/* </div> */}

            {tab === "main" && (
              <JobCampaignsMain
                setTab={setTab}
                setModalCampaigns={setModalCampaigns}
                setModalDataCampaigns={setModalDataCampaigns}
                campaignData={campaignData}
                paginationData={paginationData}
                onPaginate={onPaginate}
                downloadCsv={downloadCsv}
                sortList={sortList}
                sortOrder={sortOrder}
                search={search}
                setSearchTextOnChange={setSearchTextOnChange}
                searchText={searchText}
                changeMediumDesc={changeMediumDesc}
                setRecommandDataId={setRecommandDataId}
                onEditCampaign={handleEditCampaign}
                onDeleteCampaign={handleDeleteCampaign}
                onRefresh={refreshCampaignData}
                onApplicationCountClick={handleApplicationCountClick}
                user={user}
                setAuth={setAuth}
                setModal={setModalSwitch}
                NotifModul={NotifModul}
                profiles={profiles}
                closeCartPanel={closeCartPanel}
                setModalNotification={setModalNotification}
                cartItem={cartItem}
                goToPricing={goToPricing}
                onHeaderTitleChange={handleHeaderTitleChange}
                selectDesc={selectDesc}
                isLoading={isFetching}
                loadMore={loadMoreData}
                hasMore={hasMore}
                isLoadingMore={isLoadingMore}
                selectedTab={selectedTab}
                setSelectedTab={handleTabChange}
                onStartChat={onStartChat}
                setOfferSelectedForReview={setOfferSelectedForReview}
              />
            )}

            {tab === "create" && (
              <JobPostMain
                setTab={setTab}
                editCampaignData={modalDataCampaigns}
                isEditMode={modalDataCampaigns !== null}
              />
            )}
          </div>
        </>
      ) : (
        <>
          <NotSubscribe
            goToPricing={goToPricing}
            type="brand"
            setAuth={setAuth}
            setModal={setModal}
            NotifModul={NotifModul}
            setNotifModul={setModalNotification}
            profiles={profiles}
            closeCartPanel={closeCartPanel}
            user={user}
            cartItem={cartItem}
            title={"Campaigns"}
            background={"background_inflist.png"}
          ></NotSubscribe>
        </>
      )}
      <AnimatePresence></AnimatePresence>

      {/* Campaign Details Modal */}
      <CampaignDetailsModal
        open={modalCampaigns === "detail"}
        onClose={() => setModalCampaigns(null)}
        campaignData={modalDataCampaigns}
      />

      {/* {toastList && toastList.length > 0 && (
        <Toast type="rate" list={toastList} setList={setToastList} />
      )} */}
    </>
  );
}
